module.exports = __webpack_public_path__ + "7afc05365e3afb39a9eda1efcc781c1c.png";